import { alpha, ComponentsPropsList } from "@mui/material";
import { Components, Theme } from "@mui/material/styles";

export const MuiButton = (theme: Theme) =>
  ({
    MuiButton: {
      defaultProps: {
        color: "inherit",
      },
      styleOverrides: {
        root: ({
          ownerState,
        }: {
          ownerState: ComponentsPropsList["MuiButton"] &
            Record<string, unknown>;
        }) => ({
          ...(ownerState.variant === "text" &&
            ownerState.color === "primary" && {
              color: theme.palette.primary.light,
            }),
          ...(ownerState.variant === "text" &&
            ownerState.color === "secondary" && {
              color: theme.palette.secondary.light,
            }),
          ...(ownerState.variant === "outlined" &&
            ownerState.color === "primary" && {
              color: theme.palette.primary.light,
              borderColor: theme.palette.primary.light,
            }),
          ...(ownerState.variant === "outlined" &&
            ownerState.color === "secondary" && {
              color: theme.palette.secondary.light,
              borderColor: theme.palette.secondary.light,
            }),
        }),
      },
      variants: [
        {
          // TODO:: match variant name with UX theme when it's added to shared palette
          props: { variant: "outlined-contained" },
          style: {
            border: "1px solid",
            backgroundColor: alpha(theme.palette.primary.main, 0.5),
            borderColor: theme.palette.primary.main,
            "&:hover": {
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
      ],
    },
  }) satisfies Components<Theme>;
